import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {
  "title": "link()",
  "order": 544
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A high-order request handler that scopes a `}<a parentName="p" {...{
        "href": "/docs/api/graphql/"
      }}>{`GraphQL API`}</a>{` under the given endpoint.`}</p>
    <p><inlineCode parentName="p">{`graphql.link()`}</inlineCode>{` is primarily designed for applications that communicate with multiple GraphQL endpoints to prevent operation name collision during API mocking.`}</p>
    <h2 {...{
      "id": "call-signature"
    }}>{`Call signature`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`interface graphql {
  link(uri: string): GraphQLRequestHandlers
}
`}</code></pre>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "showLineNumbers focusedLines=3-4,7-8",
        "showLineNumbers": true,
        "focusedLines": "3-4,7-8"
      }}>{`import { setupWorker, graphql } from 'msw'

const github = graphql.link('https://api.github.com/v4')
const stripe = graphql.link('https://api.stripe.com/graphql')

const worker = setupWorker(
  github.query('GetUser', resolveGitHubUser),
  stripe.mutation('Payment', resolveStripePayment),

  // Although this operation name is \`GetUser\`,
  // it will get captured only when the request is issued
  // against the current location (no link specified).
  graphql.query('GetUser', (req, res, ctx) => {
    return res()
  }),
)

worker.start()
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      